import {useContext, useEffect, useState} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faBars,
    faInfo,
    faHistory,
    faList,
    faUser,
    faXmark,
    faGears,
    faHouse,
    faArrowLeft
} from '@fortawesome/free-solid-svg-icons'

import "./SidePanel.css";
import SideOverview from "./overview/SideOverview";
import SidePersonal from "./account/SidePersonal";
import {UserContext} from "../contexts/UserContext";
import OwnerInfo from "./account/OwnerInfo";
import {ProposalContext} from "../contexts/ProposalContext";
import {UiActions, UiContext, UiDispatchContext} from "../contexts/UiContext";

export default function SidePanel() {
    const [uiState, uiStateDispatch] = [useContext(UiContext), useContext(UiDispatchContext)];
    const user = useContext(UserContext);
    const proposal = useContext(ProposalContext);
    const pages = [
        {
            element: <SideOverview/>,
            icon: faHouse,
        },
        {
            element: <SidePersonal/>,
            icon: faUser,
        },
    ];
    if (user.value !== null && user.value.isOwner) {
        pages.push({
            element: <OwnerInfo/>,
            icon: faGears,
        });
    }
    // Safeguard for when the user logs out while the side panel is mounted.
    if (uiState.sidePanelPageIdx >= pages.length) {
        uiStateDispatch({type: UiActions.SetSidePanelPageIdx, pageIdx: pages.length - 1});
    }

    const reviewingProposal = proposal !== null && proposal.beingReviewed;
    return (
        <>
            {!reviewingProposal && !uiState.sidePanelOpen &&
                <button
                    id="open-navigation-button"
                    onClick={() => uiStateDispatch({type: UiActions.OpenSidePanel})}
                    className="text-2xl sm:text-3xl px-2.5 pt-1.5 pb-1 absolute sm:top-4 sm:left-4 left-2 top-2"
                >
                    <FontAwesomeIcon
                        icon={faBars}
                    />
                </button>
            }
            {!reviewingProposal &&
                <div id="side-navigation" className={uiState.sidePanelOpen ? "open-side-navigation" : "closed-side-navigation"}>
                    <div
                        onClick={() => uiStateDispatch({type: UiActions.CloseSidePanel})}
                        className="text-white pt-5 px-5 mb-7 flex justify-between space-x-4 cursor-pointer"
                    >
                        <img src="logo.png" alt="Climbuddy.com logo" width="200"/>
                        <FontAwesomeIcon icon={faXmark} size="2x" className="mt-2 pr-1"/>
                    </div>
                    <div id="bottom-navigation">
                        {pages.map(({icon}, idx) => {
                            return (
                                <button
                                    key={idx}
                                    className={"nav-btn" + (idx === uiState.sidePanelPageIdx ? " open-nav-btn" : "")}
                                    onClick={() => uiStateDispatch({type: UiActions.SetSidePanelPageIdx, pageIdx: idx})}
                                >
                                    <FontAwesomeIcon icon={icon} size="lg"/>
                                </button>
                            );
                        })}
                    </div>
                    <div id="side-content">
                        {pages[uiState.sidePanelPageIdx].element}
                    </div>
                </div>
            }
        </>);
}